import { eventBus as sharedEventBus } from "@/shared/events";
import type { EventMap } from "@/shared/events";

export type AlertPayload = EventMap["alert"];
export type AlertListener = (payload: AlertPayload) => void;

/**
 * Compatibility facade for the migrated company pages.
 * There is still only one event bus: all calls delegate to src/events.
 */
export function useEventBus() {
  const api = {
    emit: (event: "alert", payload: AlertPayload): void => {
      sharedEventBus.emit(event, payload);
    },
    emitAsync: (event: "alert", payload: AlertPayload): Promise<void> => {
      sharedEventBus.emit(event, payload);
      return Promise.resolve();
    },
    on: (event: "alert", listener: AlertListener): void => {
      sharedEventBus.on(event, listener);
    },
    off: (event: "alert", listener?: AlertListener): void => {
      sharedEventBus.off(event, listener);
    },
    once: (event: "alert", listener: AlertListener): void => {
      const wrapped: AlertListener = (payload) => {
        api.off(event, wrapped);
        listener(payload);
      };
      api.on(event, wrapped);
    },
  };
  return api;
}

export const eventBus = useEventBus();
